<template>
  <div class="compont-calendar">
    <div id="cal" class="Calendar calendarList">
      <div id="top" class="month-top clearFloat">
        <span class="title pull-left">
          <a href="javascript:;" style="margin-right:8px">{{$t('Calendar.title')}}</a>
        </span>
        <div class="month">
          <span class="btn prev" @click="clickPrev()">
            <i class="el-icon-arrow-left"></i>
          </span>
          <!-- <span @click="yearClick">{{year}}年</span>
          <ul v-if="yearVisable" class="year-list list">
            <li v-for="(item,$index) in yearList" :key="$index" @click="yearSelect(item)">{{item}}年</li>
          </ul>
          <span @click="monthClick">{{month}}月</span>-->
          <div class="show-time">
            <span>{{year}}{{$t('Calendar.label_text1')}}{{month}}{{$t('Calendar.label_text2')}}</span>
            <el-date-picker
              v-model="showTime"
              type="month"
              :placeholder="$t('Calendar.placeholder1')"
              value-format="yyyy-MM"
              @change="onChaneTime()"
            ></el-date-picker>
          </div>
          <span class="btn next" @click="clickNext()">
            <i class="el-icon-arrow-right"></i>
          </span>
          <!-- <ul v-if="monthVisable" class="month-list list">
            <li v-for="(item,$index) in monthList" :key="$index" @click="monthSelect(item)">{{item}}</li>
          </ul>-->
        </div>
        <span class="create pull-right">
          <a href="javascript:;" style="margin-right:8px" @click="handClckCalendar()">
            <i class="el-icon-plus"></i>
            <span>{{$t('Calendar.btn_text1')}}</span>
          </a>
        </span>
      </div>
      <ul id="wk" class="week-list">
        <li>{{$t('Calendar.wk1')}}</li>
        <li>一</li>
        <li>{{$t('Calendar.wk3')}}</li>
        <li>{{$t('Calendar.wk4')}}</li>
        <li>{{$t('Calendar.wk5')}}</li>
        <li>{{$t('Calendar.wk6')}}</li>
        <li>{{$t('Calendar.wk7')}}</li>
      </ul>
      <div id="cm">
        <ul class="month-list clearFloat">
          <li
            v-for="(item,$index) in filteredItems"
            :key="$index"
            :class="{'isevent':item.event_id}"
            @click="selectStyle (item, $index)"
          >
            <!-- <span v-if="item.day==currentDay" class="active">{{item}}</span> -->
            <span
              :class="{'active':item.active,'unactive':!item.active,'preDay':item.preDay}"
            >{{item.day}}</span>
          </li>
        </ul>
      </div>
      <div id="bm">
        <span class="font-gray text-1" @click="clickExpand">
          <span v-if="!isExpand">{{$t('Calendar.btn_text2')}}</span>
          <span v-if="isExpand">{{$t('Calendar.btn_text3')}}</span>
          <i v-if="!isExpand" class="el-icon-arrow-down"></i>
          <i v-if="isExpand" class="el-icon-arrow-up"></i>
        </span>
      </div>
      <div class="event-list text-1">
        <div class="event-row" v-for="(item,index) in eventList" :key="index">
          <span></span>
          <div v-if="parseInt(item.client_id)>0" class="event-cont list-event" @click="handSeeEvent(item)">{{item.event_remark}}</div>
          <div v-else class="event-cont">{{item.event_remark}}</div>
        </div>
      </div>
    </div>
    <!-- //创建日程 -->
    <SliderBox
      :showSliderBox="showSliderCreateBox"
      @hideSliderBox="hideSliderBox"
      :sliderWidth="sliderWidth"
    >
      <div class="silder-contain slider-calendar">
        <el-form ref="form" :model="form" :rules="rules" label-width="65px">
          <div class="slider-top clearFloat slider-top-create">
            <p class="h3 slider-title pull-left">{{$t('Calendar.label_text3')}}</p>
            <div class="pull-right h1 btn-close font-gray" @click="hideSliderBox">
              <i class="el-icon-close"></i>
            </div>
            <el-button
              type="primary"
              class="pull-right"
              @click="addonSubmit()"
            >{{$t('Common.btn_confirm')}}</el-button>
          </div>
          <div class="slider-cont calendar-cont text-1">
            <p class="form-small-title h3">{{$t('Calendar.title')}}</p>

            <div class="cont-time" style="margin-bottom:20px;">
              <el-form-item :label="$t('Calendar.label_text4')" prop="event_time">
                <!-- <el-checkbox v-model="checked">全天</el-checkbox> -->
                <div class="time">
                  <el-date-picker
                    v-model="form.event_time"
                    type="date"
                    style="width: 420px;"
                    :placeholder="$t('Calendar.placeholder2')"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                  <!-- <span>—</span>
                                <el-date-picker
                                  v-model="value1"
                                  type="datetime"
                                  style="width: 180px;"
                                  placeholder="结束时间"
                  ></el-date-picker>-->
                </div>
              </el-form-item>
              <!-- <el-form-item label="提醒：">
                        <el-select filterable v-model="form.textare" style="width: 420px;" placeholder="请选择提醒时间">
                          <el-option label="类型一" value="类型一"></el-option>
                          <el-option label="类型二" value="类型二"></el-option>
                        </el-select>
              </el-form-item>-->
            </div>
            <el-form-item label prop="event_remark" class="cont-calendar">
              <el-input
                type="textarea"
                style="width: 100%;"
                :placeholder="$t('Calendar.placeholder3')"
                v-model="form.event_remark"
              ></el-input>
              <!-- <div class="cont-bottom"> -->
              <!-- <i class="el-icon-picture"></i>
                <i class="el-icon-menu"></i>
              <i class="el-icon-picture-outline"></i>-->
              <!-- </div> -->
            </el-form-item>
          </div>
        </el-form>
      </div>
    </SliderBox>
  </div>
</template>

<script>
import Vue from "vue";
import SliderBox from "../../components/SliderBox.vue";
import storeHome from "../../views/Home/home.js";
export default {
  name: "Calendar",
  props: ["calendar"],
  data() {
    return {
      active: false,
      yearVisable: false,
      monthVisable: false,
      showSliderCreateBox: false,
      sliderWidth: "600px",
      isExpand: false, //是否点击展开全月
      showTime: "", //时间
      year: "",
      month: "",
      currentDay: "",
      currentyearMonth: "",
      yearMonth: "",
      checked: "",
      value1: "",
      yearList: ["2050", "2049", "2048", "2016", "2015", "2014", "2013"],
      monthList: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12"
      ],
      form: {
        event_time: "",
        event_remark: ""
      },
      dayList: [], //显示的天
      prevdayList: [], //上个月的天数
      alldayList: [], //暂存显示的天
      weekList: [], //显示当前的周
      eventList: [], //显示的事件
      // 表单验证
      rules: {
        event_time: [
          {
            required: true,
            message: this.$t("Calendar.rules_text1"),
            trigger: "change"
          }
        ],
        event_remark: [
          {
            required: true,
            message: this.$t("Calendar.rules_text2"),
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    // this.school_id = this.$Tool.getStorage("school_id");
    var yearArr = [];
    for (var i = 1900; i <= 2050; i++) {
      yearArr.push(i);
    }
    this.yearList = yearArr;
    this.year = this.getDateyear();
    this.month = this.getDatemonth();
    this.currentDay = this.getDateday();
    this.currentyearMonth = this.getDateyear() + "-" + this.getDatemonth();
    this.yearMonth = this.getDateyear() + "-" + this.getDatemonth();
    
    let prevyearmonth;
    if (this.getDatemonth() == 1) {
      prevyearmonth = this.getDateyear() - 1 + "-" + 12;
    } else {
      prevyearmonth = this.getDateyear() + "-" + (this.getDatemonth() - 1);
    }
    this.getCalendarDatePrev(prevyearmonth);
    // 月份列表日程展示
    // let data = {
    //     marketer_id: this.marketer_id,
    //     token: this.token,
    //     school_id: this.school_id,
    //     yearMonth: this.yearMonth
    // };
    // // (() => {})(this.calendar)
    // this.getCalendarDate(data);
    // 默认显示当前的日程安排
    // 某日的日程安排
    var eventTime =
      this.getDateyear() + "-" + this.getDatemonth() + "-" + this.getDateday();
    this.showTime = eventTime;
    let data3 = {
      marketer_id: this.marketer_id,
      token: this.token,
      company_id: this.company_id,
      school_id: this.school_id,
      event_time: eventTime
    };
    this.setScheduleDate(data3);
  },
  components: {
    SliderBox
  },
  computed: {
    filteredItems: function() {
      if (this.isExpand == false) {
        return (this.dayList = this.weekList);
      } else {
        return (this.dayList = this.alldayList);
      }
    }
  },
  methods: {
    // 获取当前的系统时间
    getDateyear() {
      var myDate = new Date(); //获取系统当前时间
      return myDate.getFullYear();
    },
    getDatemonth() {
      var myDate = new Date(); //获取系统当前时间
      var month = myDate.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
        // month=parseInt(month);
      }
      return month;
    },
    getDateday() {
      var myDate = new Date(); //获取系统当前时间
      var day = myDate.getDate();
      if (day < 10) {
        day = "0" + day;
        // month=parseInt(month);
      }
      return day;
    },
    // 月份列表日程展示
    getCalendarDate(param) {
      storeHome.getCalendar(param).then(res => {
        // 
        // this.alldayList = res.data.data.data;
        this.weekList = res.data.data.theWeek;
        var current_day = this.currentDay;
        var currentyearMonth = this.currentyearMonth;
        var $allday = res.data.data.data;
        
        this.weekList.forEach(function(item) {
          if (current_day == item.day && currentyearMonth == item.yearMonth) {
            Vue.set(item, "active", true);
          }
        });
        var $prevday = this.prevdayList;
        // (() => {})($allday)
        $allday.forEach(function(item, index) {
          if (current_day == item.day && currentyearMonth == item.yearMonth) {
            Vue.set(item, "active", true);
          }
          if (index == 0) {
            
            switch (parseInt(item.week)) {
              case 0:
                break;
              case 1:
                $allday.unshift($prevday.slice(-1)[0]);
                break;
              case 2:
                $allday.unshift($prevday.slice(-2)[0]);
                $allday.unshift($prevday.slice(-2)[1]);
                break;
              case 3:
                $allday.unshift($prevday.slice(-3)[0]);
                $allday.unshift($prevday.slice(-3)[1]);
                $allday.unshift($prevday.slice(-3)[2]);
                break;
              case 4:
                $allday.unshift($prevday.slice(-4)[0]);
                $allday.unshift($prevday.slice(-4)[1]);
                $allday.unshift($prevday.slice(-4)[2]);
                $allday.unshift($prevday.slice(-4)[3]);
                break;
              case 5:
                $allday.unshift($prevday.slice(-5)[0]);
                $allday.unshift($prevday.slice(-5)[1]);
                $allday.unshift($prevday.slice(-5)[2]);
                $allday.unshift($prevday.slice(-5)[3]);
                $allday.unshift($prevday.slice(-5)[4]);
                break;
              case 6:
                $allday.unshift($prevday.slice(-6)[0]);
                $allday.unshift($prevday.slice(-6)[1]);
                $allday.unshift($prevday.slice(-6)[2]);
                $allday.unshift($prevday.slice(-6)[3]);
                $allday.unshift($prevday.slice(-6)[4]);
                $allday.unshift($prevday.slice(-6)[5]);
                break;
            }
          }
        });
        // (() => {})($allday)
        this.alldayList = $allday;
      });
    },
    // 月份列表日程展示(上个月)
    getCalendarDatePrev(yearMonth) {
      storeHome
        .getCalendar({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          yearMonth: yearMonth
        })
        .then(res => {
          this.prevdayList = res.data.data.data;
          this.prevdayList.forEach(function(item) {
            Vue.set(item, "preDay", true);
          });
          //当前月的时间
          let data = {
            marketer_id: this.marketer_id,
            token: this.token,
            company_id: this.company_id,
            school_id: this.school_id,
            yearMonth: this.yearMonth
          };
          // (() => {})(this.calendar)
          this.getCalendarDate(data);
        });
    },
    // 某日的日程安排
    setScheduleDate(param) {
      storeHome.setSchedule(param).then(res => {
        this.eventList = res.data.data.data;
        
      });
    },
    //添加日程安排提交
    addonSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          storeHome
            .addSchedule({
              marketer_id: this.marketer_id,
              token: this.token,
              school_id: this.school_id,
              company_id: this.company_id,
              event_time: this.form.event_time,
              event_remark: this.form.event_remark
            })
            .then(res => {
              (() => {})(res.data);
              if (res.data.code === 200) {
                // this.$Tool.successTip(res.data.msg);
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                let data = {
                  marketer_id: this.marketer_id,
                  token: this.token,
                  company_id: this.company_id,
                  school_id: this.school_id,
                  yearMonth: this.yearMonth
                };
                this.getCalendarDate(data);
                this.showSliderCreateBox = false;
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
              // this.dayList = res.data.data.data;
            });
        } else {
          this.$message({
            message: this.$t('Common.errorMessage'),
            type: "error"
          });
          return false;
        }
      });
    },
    // 创建点击
    handClckCalendar() {
      this.form = {
        event_time: "",
        event_remark: ""
      }; //数据初始化
      this.showSliderCreateBox = true;
    },
    hideSliderBox() {
      this.showSliderCreateBox = false;
    },
    yearClick() {
      this.monthVisable = false;
      if (this.yearVisable == false) {
        this.yearVisable = true;
      } else {
        this.yearVisable = false;
      }
    },
    monthClick() {
      this.yearVisable = false;
      if (this.monthVisable == false) {
        this.monthVisable = true;
      } else {
        this.monthVisable = false;
      }
    },
    // 年份选择
    yearSelect(val) {
      this.year = val;
      this.yearMonth = this.year + "-" + this.month;
      this.yearVisable = false;
      let prevyearmonth;
      if (this.month == 1) {
        prevyearmonth = this.year - 1 + "-" + 12;
      } else {
        prevyearmonth = this.year + "-" + (this.month - 1);
      }
      this.getCalendarDatePrev(prevyearmonth);
      let data = {
        marketer_id: this.marketer_id,
        token: this.token,
        company_id: this.company_id,
        school_id: this.school_id,
        yearMonth: this.yearMonth
      };
      this.getCalendarDate(data);
    },
    // 月份选择
    monthSelect(val) {
      this.month = val;
      this.yearMonth = this.year + "-" + this.month;
      this.monthVisable = false;
      let prevyearmonth;
      if (this.month == 1) {
        prevyearmonth = this.year - 1 + "-" + 12;
      } else {
        prevyearmonth = this.year + "-" + (this.month - 1);
      }
      this.getCalendarDatePrev(prevyearmonth);
      let data = {
        marketer_id: this.marketer_id,
        token: this.token,
        company_id: this.company_id,
        school_id: this.school_id,
        yearMonth: this.yearMonth
      };
      this.getCalendarDate(data);
    },
    selectStyle(item, index) {
      (() => {})(index, item.day);
      var event_time = this.year + "-" + this.month + "-" + item.day;
      this.$nextTick(function() {
        this.dayList.forEach(function(item) {
          Vue.set(item, "active", false);
        });
        Vue.set(item, "active", true);
      });
      // 某日的日程安排
      let data = {
        marketer_id: this.marketer_id,
        token: this.token,
        company_id: this.company_id,
        school_id: this.school_id,
        event_time: event_time
      };
      this.setScheduleDate(data);
    },
    clickExpand() {
      if (this.isExpand == false) {
        let timer = setTimeout(() => {
          this.isExpand = true;
          clearTimeout(timer);
        }, 10);
      } else {
        this.isExpand = false;
      }
    },
    // 年月选择
    onChaneTime() {
      (() => {})(this.showTime, 1213133);
      let time = this.showTime;
      if (time) {
        time = time.split("-");
        this.year = time[0];
        this.month = time[1];
        this.yearMonth = this.year + "-" + this.month;
        this.monthVisable = false;
        let prevyearmonth;
        if (this.month == 1) {
          prevyearmonth = this.year - 1 + "-" + 12;
        } else {
          prevyearmonth = this.year + "-" + (this.month - 1);
        }
        this.getCalendarDatePrev(prevyearmonth);
        let data = {
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          yearMonth: this.yearMonth
        };
        this.getCalendarDate(data);
      }
    },
    // 年月的左右切换
    clickPrev() {
      (() => {})(this.year, this.month);
      var year = parseInt(this.year);
      var month = parseInt(this.month);
      if (month == 1) {
        year = year - 1;
        month = 12;
      } else {
        month = month - 1;
      }
      this.year = year;
      if (month < 10) {
        this.month = "0" + month;
      } else {
        this.month = month;
      }
      let prevyearmonth;
      if (this.month == 1) {
        prevyearmonth = this.year - 1 + "-" + 12;
      } else {
        prevyearmonth = this.year + "-" + (this.month - 1);
      }
      this.getCalendarDatePrev(prevyearmonth);
      this.yearMonth = this.year + "-" + this.month;
      this.showTime = this.yearMonth;
      let data = {
        marketer_id: this.marketer_id,
        token: this.token,
        company_id: this.company_id,
        school_id: this.school_id,
        yearMonth: this.yearMonth
      };
      // (() => {})(this.calendar)
      this.getCalendarDate(data);
    },
    clickNext() {
      var year = parseInt(this.year);
      var month = parseInt(this.month);
      if (month == 12) {
        year = year + 1;
        month = 1;
      } else {
        month = month + 1;
      }
      this.year = year;
      if (month < 10) {
        this.month = "0" + month;
      } else {
        this.month = month;
      }
      let prevyearmonth;
      if (this.month == 1) {
        prevyearmonth = this.year - 1 + "-" + 12;
      } else {
        prevyearmonth = this.year + "-" + (this.month - 1);
      }
      this.getCalendarDatePrev(prevyearmonth);
      this.yearMonth = this.year + "-" + this.month;
      this.showTime = this.yearMonth;
      let data = {
        marketer_id: this.marketer_id,
        token: this.token,
        company_id: this.company_id,
        school_id: this.school_id,
        yearMonth: this.yearMonth
      };
      // (() => {})(this.calendar)
      this.getCalendarDate(data);
    },
    // 查看日程提醒进行跟进
    handSeeEvent(item){
      this.$emit('handSeeEvent',item)
    }
  },
  watch: {}
};
</script>

<style lang="less">
@import url("../../assets/less/manage.less");

.compont-calendar {
  //侧边栏样式
  .calendar-cont {
    margin-top: 20px;
  }

  .silder-contain .slider-cont {
    .form-small-title {
      margin-left: 0px;
    }

    .cont-calendar {
      // border: 1px solid #dddddd;
      // border-radius: 3px;

      .el-textarea__inner {
        border: none;
        min-height: 300px !important;
      }
      .el-textarea {
        border: 1px solid #dddddd;
        background: #f4f5f7;
        // border-bottom: 25px solid #f4f5f7;
        border-radius: 3px;
        padding-bottom: 25px;
      }
      .el-form-item__content {
        margin-left: 0px !important;
      }

      .cont-bottom {
        background: #f4f5f7;
        font-size: 24px;
        padding: 15px 10px;
        color: #aaa;
      }
    }

    .cont-time {
      background: #f4f5f7;
      border: 1px solid #dddddd;
      // border-bottom: 15px solid #f4f5f7;
      margin-top: 20px;
      padding: 10px 0px;

      .time {
        > span {
          display: inline-block;
          margin: 0 22px;
        }
      }
    }
  }

  .preDay {
    color: #ddd;
  }

  #cal {
    width: 100%;
    font-size: 14px;
    margin: 0;

    .month {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      .btn {
        width: 25px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        border-radius: 3px;
        border: 1px solid #20a8d8;
        display: inline-block;
        margin: 0px 8px;
      }
      .show-time {
        position: relative;
        cursor: pointer;
        .el-date-editor {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          opacity: 0;
          height: 18px !important;
          line-height: 18px !important;
          width: 80px;
          input {
            padding: 0;
            height: 18px !important;
            line-height: 18px !important;
          }
        }
      }
    }

    .list {
      width: 50%;
      background: #fff;
      border: 1px solid #ddd;
      position: absolute;
      border-radius: 2px;
      padding: 5px 0px;
      top: 90%;
      color: #888;
      z-index: 100;
      text-align: center;

      li:hover {
        color: #20a8d8;
      }

      li {
        line-height: 26px;
      }
    }

    .year-list {
      left: 14px;
      max-height: 300px;
      overflow-y: auto;
    }

    .month-list {
      right: 10px;
    }
  }

  #cal #top {
    // height: 15px;
    width: 100%;
    line-height: 15px;
    color: #20a8d8;
    position: relative;
    display: flex;
    clear: both;

    a {
      display: inline-block;
    }

    .title {
      width: 42px;
    }

    .create {
      width: 50px;
    }

    .title a {
      color: #333;
      padding-left: 5px;
      border-left: 1px solid #20a8d8;
    }

    .create a {
      color: #20a8d8;
    }

    .month {
      // margin-left: 15%;
      width: calc(100% - 95px);
      margin: 0 auto;
      text-align: center;
      //   display: inline-block;
      cursor: pointer;
    }
  }

  #cal ul#wk {
    margin: 0;
    padding: 0;
    height: 35px;
    width: 100%;
    margin: 15px auto;
    color: #888;
    font-size: 14px;
    border-bottom: 1px solid #ddd;
  }

  #cal ul#wk li {
    float: left;
    width: 14%;
    text-align: center;
    line-height: 25px;
    list-style: none;
  }

  #cal #cm {
    position: relative;

    .month-list {
      clear: left;
      color: #333;
      width: 100%;
      margin: 0 auto;
      margin-top: 10px;

      li {
        float: left;
        width: 14%;
        cursor: pointer;
        text-align: center;
        line-height: 25px;
        list-style: none;

        > span {
          display: inline-block;
          position: relative;
          height: 20px;
          line-height: 20px;
          width: 30px;
        }
      }

      .isevent {
        > span:after {
          content: "";
          position: absolute;
          top: 18px;
          left: 45%;
          display: inline-block;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: #20a8d8;
        }

        .active:after {
          content: "";
          width: 0px;
          height: 0px;
        }
      }

      .active {
        color: #fff;
        border-radius: 10px;
        background: #20a8d8;
      }
    }
  }

  #cal #bm {
    text-align: center;
    height: 30px;
    line-height: 30px;
    margin-top: 10px;
    padding: 0 13px 0 0;
    clear: both;
    padding: 0 10px;
    font-size: 14px;
    cursor: pointer;
  }

  .event-list {
    .event-row {
      margin-bottom: 10px;
      padding-left: 5%;
      display: flex;
      // align-items: center;
      span {
        width: 10px;
        height: 10px;
        display: inline-block;
        margin-top: 4.5px;
        margin-right: 5px;
        background: #ed471a;
        border-radius: 50%;
      }
      .event-cont{
        line-height: 19px;
        word-break: break-all;
        flex: 1;
      }
      .list-event{
        cursor: pointer;
      }
      .list-event:hover{
        color: #20a8d8;
      }
    }
  }

  #cal .step {
    float: right;
    font-size: 16px;
  }

  #cal .step span {
    cursor: pointer;
  }

  // 新建日程侧边栏样式
  .slider-calendar {
    .el-form {
      padding: 0px 0px 0 0px;
    }
  }

  @media (min-width: 1910px) {
    // #cal #top .month {
    //     margin-left: 25%;
    // }
  }

  @media (min-width: 1350px) and (max-width: 1390px) {
    // #cal #top .month {
    //     margin-left: 10%;
    // }
  }

  @media (min-width: 1200px) and (max-width: 1255px) {
    // #cal #top .month {
    //     margin-left: 10%;
    // }
  }
}
</style>
